import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CATALOG, LANGUAGE } from 'src/core-lib/misselaineous/boot.tokens';
import { ContentCacheUtils } from 'src/utils/storage.util';

@Component({
    selector: 'app-catalog-selector',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './catalog-selector.component.html',
    styleUrl: './catalog-selector.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogSelectorComponent {
    catalogs: { svg: string; url: string; checked: boolean; translate: string; }[];
    current: string;
    currentSvg: string;

    constructor(
        @Inject(CATALOG)
        private currentCatalog: string
    ) {
        this.current = (ContentCacheUtils
            .catalogs() ?? []).find(catalog => catalog?.cultureInfo?.toLowerCase() ?? '' == this.currentCatalog?.toLowerCase() ?? 'da-dk')?.cultureInfo?.toLowerCase() ?? 'da-dk';
        this.currentSvg = 'url(/dist/assets/flags/' + new Intl.Locale(this.current).language + '.svg)';
        this.catalogs = ContentCacheUtils
            .catalogs()
            .map(catalog => {
                let lowerCatalog = catalog
                    .cultureInfo
                    .toLowerCase();
                let url = new URL(catalog.catalogId, window.location.origin);
                url.searchParams.set('redirectTo', 'preferedCatalog')
                return {
                    svg: 'url(/dist/assets/flags/' + new Intl.Locale(lowerCatalog).language + '.svg)',
                    url: url.href,
                    checked: currentCatalog == catalog.catalogId.toLowerCase(),
                    translate: catalog
                        .cultureInfo
                        .replace('-', '')
                        .toUpperCase()
                }
            });
    }
}
